module.exports = __webpack_public_path__ + "static/media/IMG_70308DH_rond.5c8d28d5.jpg";